import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const MIRAMARSTORMDRAINLINES_LAYER_ID = 'miramarStormDrainLinesLayer';

const layerConfig = {
  title: 'Storm Drain Lines',
};

function MiramarStormDrainLinesLayer() {
  const dispatch = useDispatch();
  const { miramarStormDrainLinesLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarStormDrainLinesLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarStormDrainLinesLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARSTORMDRAINLINES_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarStormDrainLinesLayer.visible,
      opacity: miramarStormDrainLinesLayer.opacity,

      getLineColor: [47, 138, 196],
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARSTORMDRAINLINES_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Storm Drain Line Details',
              includeColumns: [
                'Storm_Drain_Line_ID',
                'Storm_Drain_Line_Subtype',
                'Storm_Drain_Line_Material',
                'Section_Length_Feet',
              ],
            }),
          };
        }
      },
    });
  }
}

export default MiramarStormDrainLinesLayer;
